<template>
  <div name="activityData" class="page">

    <section slot="pdf-content">
    <div id="printable" ref="html2Pdf">
      <section class="bg-white rounded w-95p mx-4 px-6 pb-6  mb-8">
        <h4 class="text-lg font-semibold mb-4">
          Raw data broken down by activity
        </h4>

        <table v-if="componentLoaded" class="table-wrapper w-full">
          <thead class="bg-gray-100 rounded">
            <tr>
              <th class="w-6/12 text-left p-2">Activity</th>
              <th class="w-2/8 text-center font-bold">Total</th>
              <th class="w-1/8 text-center">Female</th>
              <th class="w-1/8 text-center">Male</th>
              <th class="w-1/8 text-center">SEN</th>
              <th class="w-1/8 text-center">PP</th>
              <th class="w-1/8 text-center">EAL</th>
            </tr>
          </thead>
          <tbody>
            <tr class="course" v-for="item in orderedActivities" :key="item.identifier">
              <td>
                <div class="upper pl-2">
                  {{ item.title }}
                </div>
              </td>
              <td class="text-center font-bold">
                {{ processTotalForActivity(item) }}
              </td>
              <td
                class="text-center"
                v-for="(value, index) in processTypesActivity(item)" :key="index"
              >
                {{ value }}
              </td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>

        <p v-else>We could not find any data for your given selection.</p>
      </section>

      <section class="bg-white rounded w-95p mx-4 px-6 pb-6 pt-4 mb-8">
        <h4 class="text-lg font-semibold mb-4">
          Raw data broken down by year group
        </h4>

        <table v-if="componentLoaded" class="table-wrapper w-full">
          <thead class="bg-gray-100 rounded">
            <tr>
              <th class="w-6/12 text-left p-2">Year</th>
              <th class="w-2/8 text-center font-bold">Total</th>
              <th class="w-1/8 text-center">Female</th>
              <th class="w-1/8 text-center">Male</th>

              <th class="w-1/8 text-center">SEN</th>
              <th class="w-1/8 text-center">PP</th>
              <th class="w-1/8 text-center">EAL</th>
            </tr>
          </thead>
          <tbody>
            <tr class="course" v-for="year in years" :key="year.id">
              <td>
                <div class="upper pl-2">
                  {{ year.name }}
                </div>
              </td>
              <td class="text-center font-bold">
                {{ processTotalForYear(year) }}
              </td>
              <td class="text-center" v-for="(value, index) in processTypesYear(year)" :key="index">
                {{ value }}
              </td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>

        <p v-else>We could not find any data for your given selection.</p>
      </section>

      <span class="html2pdf__page-break">&nbsp;</span>

      <section class="bg-white rounded w-95p mx-4 px-6 pb-6 mb-8 ">
        <h4 class="text-lg font-semibold mb-4 ">
          Raw data broken down by term
        </h4>

        <table v-if="componentLoaded" class="table-wrapper w-full">
          <thead class="bg-gray-100 rounded">
            <tr>
              <th class="w-5/12 text-left p-2">Term</th>
              <th class="w-1/8 text-center font-bold">Activity Total</th>
              <th class="w-1/8 text-center font-bold">Pupil Total</th>
              <th class="w-1/8 text-center">Female</th>
              <th class="w-1/8 text-center">Male</th>

              <th class="w-1/8 text-center">SEN</th>
              <th class="w-1/8 text-center">PP</th>
              <th class="w-1/8 text-center">EAL</th>
            </tr>
          </thead>
          <tbody>
            <tr class="course" v-for="term in terms" :key="term.id">
              <td>
                <div class="upper pl-2">
                  {{ term.name }}
                </div>
              </td>
              <td class="text-center font-bold">
                {{ processTotalForTerm(term) }}
              </td>
              <td class="text-center font-bold">
                {{ processPupilTotalForTerm(term) }}
              </td>
              <td class="text-center" v-for="(value, index) in processTypesTerm(term)" :key="index">
              {{ value }}
              </td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>

        <p v-else>We could not find any data for your given selection.</p>
      </section>
    </div>
    </section>
  </div>
</template>

<script>
import {
  reportGridCalculation,
  reportGridCountCalculation,
  uniqueOnlyRegisters,
  termList,
} from "@/assets/js/utils";

export default {
  name: "activityData",
  props: ["activities", "years", "types"],
  computed: {
    componentLoaded() {
      return this.activities.length > 0;
    },
    orderedActivities() {
      return _.orderBy(this.activities, ["title"]);
    },
  },

  data() {
    return {
      terms: termList(),
    };
  },
  mounted() {},
  methods: {
    generateReport() {
        this.$refs.html2Pdf.generatePdf()
    },
    processTotalForActivity(activity) {
      var list = this.activities.filter(function (row) {
        let filtered = true;
        filtered = row.identifier === activity.identifier;

        if (filtered) {
          if (row.pupils != undefined) {
            filtered = row.pupils.length > 0;
          }
        }

        return filtered;
      });

      if (list.length === 0) {
        return 0;
      }

      let vm = this;
      let results = reportGridCalculation(null, list);

      return results;
    },
    processTypesActivity(item) {
      var list = this.activities.filter(function (row) {
        let filtered = true;
        filtered = row.identifier === item.identifier;

        if (filtered) {
          if (row.pupils != undefined) {
            filtered = row.pupils.length > 0;
          }
        }

        return filtered;
      });

      if (list.length === 0) {
        return this.types.map(function (type) {
          return 0;
        });
      }

      let results = this.types.map(function (type) {
        return reportGridCalculation(type.value, list);
      });

      return results;
    },
    processTotalForYear(year) {
      var list = this.activities.filter(function(row) {
        let filtered = true;
       if (row.pupils != undefined) {
          filtered = row.pupils.length > 0;
        }

        return filtered;
      });

      let repping = list.flatMap(function(activity) {
        let pupils =  activity.pupils != undefined ?  activity.pupils : []
        return pupils.map(function(reg) {
          return reg.yeargroup === year.value ? reg : null;
        });
      }).filter(n => n);
     
      let uniqueRegisters = uniqueOnlyRegisters(repping)
      let values = [{pupils: uniqueRegisters}]

     let results = reportGridCalculation(null, values)
     return results;
    },
    processTypesYear(year) {
      var list = this.activities.filter(function(row) {
        let filtered = true;
       if (row.pupils != undefined) {
          filtered = row.pupils.length > 0;
        }

        return filtered;
      });

      let repping = list.flatMap(function(activity) {
        let pupils =  activity.pupils != undefined ?  activity.pupils : []
        return pupils.map(function(reg) {
          return reg.yeargroup === year.value ? reg : null;
        });
      }).filter(n => n);

      if (list.length === 0) {
        return this.types.map(function (type) {
          return 0;
        });
      }

      let uniqueRegisters = uniqueOnlyRegisters(repping)
      let values = [{pupils: uniqueRegisters}]

      let results = this.types.map(function (type) {
        return reportGridCalculation(type.value, values);
      });

      return results;
    },
    processTotalForTerm(term) {
      var list = this.activities.filter(function (row) {
        let filtered = true;

        let selectedTerms = row.term.split(",");
        filtered = selectedTerms.includes(term.key)

        return filtered;
      });

      if (list.length === 0) {
        return 0;
      }


      return list.length;
    },
    processPupilTotalForTerm(term) {
      var list = this.activities.filter(function (row) {
        let filtered = true;

        let selectedTerms = row.term.split(",");

        filtered = selectedTerms.includes(term.key)

        if (filtered && row.pupils != undefined) {
          filtered = row.pupils.length > 0;
        }

        return filtered;
      });

      if (list.length === 0) {
        return 0;
      }

      let results = reportGridCountCalculation(null, list);

      return results;
    },
    processTypesTerm(term) {
      var list = this.activities.filter(function (row) {
        let filtered = true;
        let selectedTerms = row.term.split(",");

        filtered = selectedTerms.includes(term.key)

        if (filtered && row.pupils != undefined) {
          filtered = row.pupils.length > 0;
        }

        return filtered;
      });

      if (list.length === 0) {
        return this.types.map(function (type) {
          return 0;
        });
      }

      let results = this.types.map(function (type) {
        return reportGridCountCalculation(type.value, list);
      });

      return results;
    },
    printReport() {
      window.print();
    },
  },
  components: {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.upper {
  text-transform: uppercase;
}

.smaller {
  font-size: 75% !important;
}

select {
  font-weight: bolder;
  font-size: 13pt;
  display: inline !important;
}
</style>
